import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/constants/routes'

export function AccountCreatedPage() {
  const { t } = useTranslation('wizard')
  const location = useLocation()
  const state = location.state as {
    isQuoteFlow?: boolean
    isCustomOfferFlow?: boolean
    isMemberFlow?: boolean
    promoCodeError?: string
  } | null
  const isQuoteFlow = state?.isQuoteFlow === true
  const isCustomOfferFlow = state?.isCustomOfferFlow === true
  const isMemberFlow = state?.isMemberFlow === true
  const promoCodeError = state?.promoCodeError

  const getTitle = () => {
    if (isCustomOfferFlow) return t('accountCreated.customOffer.title')
    if (isQuoteFlow) return t('accountCreated.quote.title')
    return t('accountCreated.title')
  }

  const getMessage = () => {
    if (isCustomOfferFlow) return t('accountCreated.customOffer.message')
    if (isQuoteFlow) return t('accountCreated.quote.message')
    if (isMemberFlow) return t('accountCreated.member.message')
    return t('accountCreated.message')
  }

  const getButtonLabel = () => {
    if (isCustomOfferFlow) return t('accountCreated.customOffer.finishButton')
    if (isQuoteFlow) return t('accountCreated.quote.accessAccountButton')
    return t('accountCreated.finishButton')
  }

  const getButtonTo = () => {
    if (isCustomOfferFlow) return ROUTES.HOME
    if (isQuoteFlow) return ROUTES.LOGIN
    return ROUTES.HOME
  }

  return (
    <div className="bg-background flex min-h-0 flex-1 flex-col items-center justify-center px-4 py-8">
      <div className="mx-auto max-w-[500px]">
        <div className="rounded-[26px] border border-[#E9E9E9] bg-white px-[54px] py-10">
          <div className="mb-4 flex justify-center">
            <img src="/check.svg" alt="" width={60} height={60} className="h-[60px] w-[60px]" />
          </div>
          <h1 className="text-foreground mb-4 text-center text-xl font-bold">{getTitle()}</h1>
          <p className="text-foreground mb-10 text-center text-base font-normal">{getMessage()}</p>
          {promoCodeError && (
            <p className="mb-6 text-center text-sm font-normal text-[#B45628]">{promoCodeError}</p>
          )}
          <div className="flex justify-center">
            <Link
              to={getButtonTo()}
              className="bg-primary text-primary-foreground rounded-md px-10 py-2.5 text-sm font-semibold transition-opacity hover:opacity-90"
            >
              {getButtonLabel()}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
